/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// our components
import qs from 'helpers/queryStrings';
import RouterContext from 'helpers/routerContext';
import { Query } from 'components/common/Query';
import ReportPaidAdList from './List';

/**
 * Query to fetch agency summary from api
 */
export const AGENCY_SUMMARY_QUERY = gql`
  query AgencySummary(
    $onlyAgencies: Boolean
    $startDateGte: DateTime!
    $startDateLte: DateTime!
  ) {
    agenciesSummaries(
      onlyAgencies: $onlyAgencies
      startDateGte: $startDateGte
      startDateLte: $startDateLte
    ) {
      summaries {
        agency {
          id
          fullname
          email
          photo {
            gcsKey
            url
          }
        }
        totalSummaries {
          grossSales
          netSales
          commissions
          count
          currency
        }
        paidAdSummaries {
          grossSales
          netSales
          commissions
          count
          currency
        }
        creditBundleSummaries {
          grossSales
          netSales
          commissions
          count
          currency
        }
      }
      total {
        grossSales
        netSales
        commissions
        count
        currency
      }
    }
  }
`;

/**
 * @class
 * @extends Component
 */
class ReportPaidAdListContainer extends Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    const { initialFilters } = props;
    const defaultFilters = {
      onlyAgencies: true,
      startDateGte: moment()
        .startOf('month')
        .format(),
      startDateLte: moment()
        .endOf('month')
        .format(),
    };
    const startDateGte =
      initialFilters.startDateGte !== undefined
        ? initialFilters.startDateGte
        : defaultFilters.startDateGte;
    const startDateLte =
      initialFilters.startDateLte !== undefined
        ? initialFilters.startDateLte
        : defaultFilters.startDateLte;
    const { ...initFilters } = initialFilters;

    this.state = {
      filters: {
        ...defaultFilters,
        ...initFilters,
        startDateGte,
        startDateLte,
      },
    };
    this.Compose = adopt({
      querySummary: this.agenciesSummary,
    });
    this.fetchMore = () => {};
  }

  /**
   * @description
   * Query callback to compose with mutations.
   *
   * @param {*} render - Query's render props.
   * @returns {*} Query component.
   */
  agenciesSummary = ({ render }) => {
    const { filters } = this.state;
    return (
      <Query
        query={AGENCY_SUMMARY_QUERY}
        variables={{
          ...filters,
        }}
        notifyOnNetworkStatusChange
        fetchPolicy="cache-and-network"
      >
        {({ data, loading, fetchMore }) => {
          this.fetchMore = fetchMore;
          return render({ data, loading, fetchMore });
        }}
      </Query>
    );
  };

  /**
   * @description
   * Filter rows according selected filters.
   *
   * @param {Object} newFilters - Filters to apply.
   */
  handleFilter = newFilters => {
    const history = this.context;
    const { filters } = this.state;
    this.setState({
      filters: {
        ...filters,
        ...newFilters,
      },
    });
    const currentLocation = history.location.pathname;
    const stringified = qs.stringify({
      ...filters,
      ...newFilters,
    });
    history.push({ pathname: currentLocation, search: stringified });
  };

  /**
   * @description
   * Refresh the list.
   * @returns {Function} - Fetch More function.
   */
  handleRefresh = () => {
    this.fetchMore({
      updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
    });
  };

  /**
   * @description
   * Render AdsList component.
   */
  render() {
    const { filters } = this.state;
    return (
      <this.Compose>
        {({ querySummary: { loading, data } }) => (
          <ReportPaidAdList
            data={data}
            appliedFilter={filters}
            filter={newFilters => this.handleFilter(newFilters)}
            refresh={this.handleRefresh}
            loading={Object.keys(data).length === 0}
            fullLoading={loading}
          />
        )}
      </this.Compose>
    );
  }
}

/**
 * ReportPaidAdListContainer PropTypes
 * @param initialFilters - prop initial Filters to apply
 */

ReportPaidAdListContainer.propTypes = {
  initialFilters: PropTypes.shape({}).isRequired,
};

export default ReportPaidAdListContainer;
